import { ArticleStatus, IInsuranceContract, PricingModelType } from '@alberta/konexi-shared';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { SingleOrderedArticleLineViewModel } from 'src/app/business/single-order/single-ordered-articleline-view-model';
import { InsuranceContractDB } from 'src/app/common/repository/databases';
import { QueryService } from 'src/app/shared/services/query/query.service';

@Component({
  selector: 'itl-prescription-article-data',
  templateUrl: 'prescription-article-data.component.html',
  styleUrls: ['prescription-article-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PrescriptionArticleDataComponent implements OnInit {
  @Input()
  articleLine: SingleOrderedArticleLineViewModel;

  public ArticleStatus = ArticleStatus;
  public articleExpanded = false;
  public contract: IInsuranceContract;
  public PricingModelType = PricingModelType;

  constructor(private _queryService: QueryService, private _changeDetectorRef: ChangeDetectorRef) {}

  async ngOnInit(): Promise<void> {
    if (this.articleLine.contractId) {
      this.contract = await this._queryService.get<IInsuranceContract>(
        this.articleLine.contractId,
        InsuranceContractDB
      );
      this._changeDetectorRef.markForCheck();
    }
  }

  public toggleShowMore() {
    this.articleExpanded = !this.articleExpanded;
  }
}
